package com.appcreator.dto

import com.appcreator.dto.configurations.ProjectTemplate
import kotlinx.serialization.Serializable

@Serializable
data class ProjectTemplatesResponse(
    val templates: List<ProjectTemplate>
)
